<template>
  <div class="container home" :style="'background-color: ' + bgColor">
    <div class="cnt">
      <ProfileTile />
      <div class="title-cnt">
        <h6 class="title primary">{{ $t("Missioni") }}</h6>
        <router-link to="/actions" class="title-link primary">{{
          $t("Vai alle missioni")
        }}</router-link>
      </div>
      <div class="missions">
        <MissionTile />
        <TaskList />
      </div>
      <AwardsTile />
      <ClassificationTile />
    </div>
  </div>
</template>

<script>
import ProfileTile from "@/components/rebuild/ProfileTile";
import MissionTile from "@/components/rebuild/MissionTile";
import TaskList from "@/components/rebuild/TaskList";
import AwardsTile from "@/components/rebuild/AwardsTile";
import ClassificationTile from "@/components/rebuild/ClassificationTile";
export default {
  name: "DashboardMobile",
  data() {
    return {
      bgColor: null
    };
  },
  components: {
    ProfileTile,
    MissionTile,
    TaskList,
    AwardsTile,
    ClassificationTile
  },
  created() {
    this.bgColor = this.$store.getters.getUser.id
      ? this.$store.state.campaign.css_settings["body-bg"]
      : "#EFF8FE";
  }
};
</script>

<style lang="scss" scoped>
.home {
  padding: 15px;
  background-color: transparent;
  padding-bottom: 100px;
}
.missions {
  margin-top: 30px;
  display: flex;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
